<template>
<div>
  <div class="container-fluid pt-5">
    <div class="row">
      <div class="d-none d-lg-flex col-md-3">
        <side-menu :showInfoTv="true" :tv="tv" :currentProgram="infoCurrentProgram" :futureProgram="futureProgram"/>
      </div>
      <div class="col-lg-9 cold-md-12">
        <div class="row d-xl-flex d-none align-items-stretch justify-content-center w-100 pb-4 pt-1">

          <div class="d-none d-md-flex col-md-5 align-items-center justify-content-start">
            <h1 class="text-white"> &nbsp;&nbsp;{{tv.descrizione}}</h1>
          </div>        

          <div class="d-none d-md-flex col-md-1"></div> 

          <div class="d-none d-md-flex col-md-6 justify-content-end">
            <div class="w-100">
              <search :back="true" :backlink="this.backlink"></search>  
            </div>
             
          </div>
            
        </div>
        <!-- MOD. RESPONSIVE -->
        <div class="row d-xl-none d-lg-flex align-items-stretch justify-content-center pb-2">
          <div class="d-flex col-md-10 justify-content-end">
            <div class="w-100">
              <search :back="true" :backlink="this.backlink"></search>  
            </div>
          </div>
          <div class="d-flex col-md-12 justify-content-center pt-4">
            <h1 class="text-white"> &nbsp;&nbsp;{{tv.descrizione}}</h1>
          </div>
        </div>    
        <div class="content-player">

        <div class="">

          <div id="player" class="player-frame-wrapper"  v-bind:style="{ 'height':  this.height + 'px' }">

          <div class="fp-footer" id="info" v-show="showInfo == true">
            <div class="row p-3">
              <div class="col-md-1">
                <img :src="tv.imageUrl" id="image-info" width="100px" height="100px">
              </div>
              <div class="d-none d-lg-block col-md-9 text-left">
                <span id="text-description">{{tv.descrizione}} </span>
                <ul class="list-unstyled">
                  <li class="title"><h6>IN ONDA {{listInfoCurrentProgram()}}</h6></li>
                  <li class="title"><h6>{{listInfoNextProgram()}}</h6></li>
                </ul>
                <!-- <p>{{currentViews}}</p> -->
                
              </div>
              <div class="d-lg-none d-block col-md-9 text-left">
                <span id="text-description">{{tv.descrizione}} </span>
                <ul class="list-unstyled">
                  <li class="title"><h6>IN ONDA {{listInfoCurrentProgram()}}</h6></li>
                  <li class="title"><h6>{{listInfoNextProgram()}}</h6></li>
                </ul>
                <!-- <p>{{currentViews}}</p> -->
                
              </div>
              <div class="d-none d-lg-block col-md-2 text-right align-items-stretch">
                <b-button v-b-modal.programmazione class="button-modal" style="vertical-align: inherit !important;"><ficon :icon="['fa', 'list-alt']" size="2x" title="Programmazione"></ficon></b-button>
                <ficon class="icon-star" :icon="['far', 'star']" size="2x" v-show="tv.favorite == false" v-on:click="changePrefer()"></ficon>
                <ficon class="icon-star" :icon="['fa', 'star']" size="2x" v-show="tv.favorite == true" v-on:click="changePrefer()"></ficon> &nbsp;&nbsp;
                <ficon :icon="['fa', 'eye']" size="2x" v-on:click="incrementaView()"></ficon> <span style="font-size:15px;"> {{currentViews}} </span>
                
              </div>
            </div>
                        
          </div>

          </div>
         
        </div>

        <footer class="navbar footer navbar-trasparent text-center px-5 pt-5">
          <main-footer />
        </footer>
        
      </div>
    </div>
  </div>


  <b-modal ref="programmazione" id="programmazione" class="modal-programmazione" size="md" hide-footer="">

    <template slot="modal-header">
      <h4 class="modal-title" style="color:#000!important;">
        <slot name="modal-title"><span class="text-white">Programmazione</span></slot>
      </h4>

    <button type="button" class="close" aria-label="headerCloseLabel" @click="hideModal" style="color:#000!important;">
      <span aria-hidden="true">x</span>
    </button>
  </template>

  <div class="row">

      <div class="col-md-12 text-left div-canale-programmazione" v-for="(item) in allFutureProgram" v-bind:key="item.start">
        <strong class="text-iptv"><ficon icon="circle" class="green" v-if="isInOnda(item.start,item.end) == true"></ficon> {{item.title}}</strong>
        <p class="text-white"><ficon :icon="['fa', 'clock']"></ficon> {{datetoHoursStr(item.start)}} - {{datetoHoursStr(item.end)}} </p>
      </div>
  </div>

   
  </b-modal>
  </div>
  </div>
</template>

<script>

    import FlowPlayerHls from 'flowplayer-hlsjs';
    import FlowPlayer from 'flowplayer';
    FlowPlayerHls(FlowPlayer);

    //import MainHeader from '@/components/MainHeader.vue'
    import MainFooter from '@/components/MainFooter.vue'
    import Tv from '../api/tv.js';
    import Epg from '../models/Epg.js';
    import utilfunc from '../models/utilfunc.js';
    import SideMenu from '@/components/SideMenu.vue'
    import Search from '@/components/Search.vue'
    import ClientWS from '../models/ClientWS'
    import Auth from '../api/Auth'
    //import detect from 'detect-browser'

    import '@/assets/css/video-js.css';
    import '@/assets/css/flowplayer.css';
    import 'flowplayer/dist/skin/skin.css';

    const { detect } = require('detect-browser');
    const browser = detect();

    //window.videojs = require('video.js');

    export default {

      name:'show',
      data: function(){
        return {
          isMonted: false,
          height: (window.innerHeight * 75) / 100,
          width: window.innerWidth,
          showInfo: false,
          backlink: "javascript:history.go(-1)",         
          currentViews: 1,
          clientWS: null,
          searchKey: "",
          infoCurrentProgram: {
            descrizione: "",
            start: "",
            end: "",
            title: ""
          },
          infoNextProgram: {
            descrizione: "",
            start: "",
            end: "",
            title: ""
          },
          futureProgram: [],
          allFutureProgram: [],
          stream: "",
          tv: {
            imageUrl: "",
            sigla: "",
            numero: "",
            favorite: false,
            inOnda: true
          }
        }
      },
      components: {
        SideMenu, Search, MainFooter
      },
      props: ['title', 'src', 'type'],
      computed: {

        currentBrowser: function(){
          let codec = '';
          
          switch (browser && browser.name) {
            case 'chrome':
              codec = 'profile=webtv-h264-vorbis-mp4';
            break;
            case 'firefox':
              codec = 'profile=webtv-vp8-vorbis-webm';
              break;
            case 'edge':
              codec = 'profile=webtv-vp8-vorbis-webm';
              break;
          
            default:
              codec = 'profile=webtv-vp8-vorbis-webm';
              console.log('not supported', browser.name);
          }
          return codec;
        }
      },    
      created: function() {
          const self = this;
          this.searchKey = this.$route.params.search_key;
          let apiTv = new Tv();
          apiTv.getTv(this.searchKey)
            .then(response => {
              if(response.data) {
                self.tv = response.data;
                self.stream = self.tv.streamUrl;          
                if(self.isMonted) {
                  self.loadVideoJs();
                }                                
              } else {
                console.log("Nessun dato ricevuto");
              }
            })
            .catch(function (error) {
                  console.log(error);                       
            });
            
                           
      },
      methods: {
          hideModal() {
            this.$refs['programmazione'].hide()
          },
           isMobile() {

            if(screen.width < 768) {
              return true
            } else {
              return false
            }
          },
          setShowInfo(param){
            if(this.tv.inOnda)
              this.showInfo = param;
          },
          changeVolume(){
            //console.log('CHANGE VOLUME')
          },
          onclickText(){
            this.currentViews++;
          },
          setVideoSize(){
            this.height= (window.innerHeight * 75) / 100;
            this.width = window.innerWidth;
          },
          getCurrentProgram(){
            let epg = new Epg(this.tv);
            this.infoCurrentProgram = epg.getCurrentProgram();
            
          },
          isInOnda(start,end){
            let start_tg = new Date(start);
            let end_tg = new Date(end);
            let current = new Date();

            if(current >= start_tg && current <= end_tg){
              return true;
            }

            return false;
          } ,
          getNextProgram(){
            let epg = new Epg(this.tv);
            //console.log(epg);
            this.infoNextProgram = epg.getNextProgram();
          },
          datetoHoursStr(date){
            return utilfunc.datetoHoursStr(date);
          },
          listInfoCurrentProgram()
          {
              let string = '';
              if(this.infoCurrentProgram != null) 
              {
                let start = utilfunc.datetoHoursStr(this.infoCurrentProgram.start);
                let end = utilfunc.datetoHoursStr(this.infoCurrentProgram.end);
                string = start + " - " + end + "  " + this.infoCurrentProgram.descrizione;

              }
              

              return  string;
          },
          listInfoNextProgram()
          {
              let string = '';
              if(this.infoNextProgram != null) 
              {

                let start = utilfunc.datetoHoursStr(this.infoNextProgram.start);
                let end = utilfunc.datetoHoursStr(this.infoNextProgram.end);
  
                string = start + " - " + end + "  " + this.infoNextProgram.descrizione;
              }

              return  string;
          },
          listfutureProgram()
          {
              let epg = new Epg(this.tv);
              this.futureProgram = epg.getFutureProgram();
          },
          listAllFutureProgram()
          {
              let epg = new Epg(this.tv);
              this.allFutureProgram = epg.getAllFutureProgram(true);
          },
          hideLogoPlayer() {
            var els = document.getElementsByTagName("a");
            if(els) {
              setTimeout(() => {
               for (var i = 0, l = els.length; i < l; i++) {
                 let el = els[i];
                 if (el.href === 'https://flowplayer.com/hello/?from=player') {
                   el.style.display = 'none';
                 }
               }
             },100);   
            }
          },
          loadVideoJs() {
            const self = this;
            if(this.stream.length > 0) {
              if (self.isMobile()){
                this.height = window.innerHeight * 60 /100
              }else { 
                this.height = window.innerHeight * 75 /100
              }
              var obj_stream = { type: "application/x-mpegurl", src: this.stream};

              if(!self.tv.inOnda){
                  
                obj_stream = { type: "video/mp4", src: "error-channel.mp4"}
              } 
          
              this.flowPlayer = FlowPlayer('#player', {
                live: true,  // set if it's a livestream
                //ratio: 9/16,
                adaptiveRatio:true,
                fullscreen: true,
                native_fullscreen: true,
                autoplay: true,
                share: false, //settato a true permette di condividere
                clip: {
                    sources: [
                        // path to the HLS m3u8
                        obj_stream
                    ]
                }
              });

              
              this.flowPlayer.on("ready", function () {
                self.hideLogoPlayer();
              });

              this.flowPlayer.on("error", function () {
                self.flowPlayer.shutdown();

                self.flowPlayer = FlowPlayer('#player', {
                  live: false,  // set if it's a livestream
                  adaptiveRatio:true,
                  fullscreen: true,
                  native_fullscreen: true,
                  autoplay: true,
                  loop:false,
                  share: false, //settato a true permette di condividere
                  clip: {
                      sources: [
                          // path to the HLS m3u8
                          { type: "video/mp4", src: "canale-non-disponibile.mp4"}
                      ]
                  }
                });
                self.hideLogoPlayer(); 
                
              });

              window.addEventListener('resize', this.setVideoSize);
              
              let div_player = document.getElementById('player');

              div_player.onclick = function() {
                self.hideLogoPlayer();  
              }

              div_player.onmouseover = function(){
                if(!self.showInfo)
                {
                    self.setShowInfo(true);
                    setTimeout(() => {
                      self.setShowInfo(false);
                    }, 7000);
                }                
              };

              div_player.ontouchstart = function () {
                self.setShowInfo(true);
                  setTimeout(() => {
                    self.setShowInfo(false);
                  }, 5000);
              };
              

              div_player.onmouseout = function(){
                //self.setShowInfo(false);
              };

              


              this.backlink = window.history.state == null ? "/" : this.backlink;
              self.getCurrentProgram();
              self.getNextProgram();
              self.listfutureProgram();
              self.listAllFutureProgram();
              self.hideLogoPlayer();  
            } 
          },
          changePrefer(event){
            let self = this;
            let searchKey = this.$route.params.search_key;
            let apiTv = new Tv();
            apiTv.setFavorite(searchKey,!this.tv.favorite)
              .then(response => {
                if(response.data) {
                  self.tv = response.data;  
                                                
                } else {
                  console.log("Nessun dato ricevuto");
                }
              })
              .catch(function (error) {
                    console.log(error);                       
              });
              if(event) event.preventDefault();     
          },
          incrementaView(){
            //this.currentViews++;
          }

      },
      mounted: function() {
        try{
          
          this.isMonted = true;
          if(this.stream.length) {
            this.loadVideoJs();
          }
          let apiAuth = new Auth();
          let url = this.configApp.wsUrl + apiAuth.getToken() + "/" + this.searchKey;
          this.clientWS = new ClientWS(url, msg => {
            msg = JSON.parse(msg);     
            if(msg.type == this.clientWS.TYPE_USER_CONNECT) {
              //console.log("TYPE_USER_CONNECT : ", msg);
            } else if(msg.type == this.clientWS.NOTIFY_CURRENT_VIEWS) {
              //console.log("NOTIFY_CURRENT_VIEWS : ", msg);
              if(msg.payload) {
                if(msg.payload.channel && msg.payload.channel == this.searchKey) {
                  this.currentViews = msg.payload.count[0];
                }
              }
            }
          });
          //############################## SE MI COMMENTI RICORDA CHE IN PRODUZIONE SERVO !!!! ###############################
          this.clientWS.open(); 
        }
        catch(err) {
          console.error(err);
        }        
      },
      
      
      beforeDestroy: function() {
        this.clientWS.close();
        if(this.flowPlayer){
          this.flowPlayer.disable();
          this.flowPlayer.shutdown();
          this.flowPlayer.engine.unload();
        }
       
      }
    }
</script>

<style scoped>
#info{
  background: rgba(43, 51, 63, 0.7);
  /*opacity: 0.9;*/
  color: yellow;
  width: 100%;
  height: 150px;
  bottom:30px;
  position: absolute;
}

#text-description {
    font-size: 2.0rem;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
  }  

/*Small devices (landscape phones, 576px and up)*/

@media (max-width: 576px) { 
  #info {
    height: 30%;
  }
  h2 {
    font-size: 1rem;
    }
  h6 {
    font-size: 0.7rem;
    }
  #image-info{
      width: 50px;
      height: 50px;
    }
 }

/*Medium devices (tablets, 768px and up)*/
@media (max-width: 768px) { 
  #info {
    height: 30%;
  }

  h2 {
    font-size: 1rem;
    }
  h6 {
    font-size: 0.7rem;
    }
  #image-info {
      width: 50px;
      height: 50px;
    }
  #text-description {
    font-size: 1.2rem;
    margin-bottom: 0;
    font-weight: 500;
    line-height: 0;
  }  
 }

 @media (max-width: 992px) { 
  #image-info {
      width: 50px;
      height: 50px;
    }
 }

</style>